import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/layer/sublayer/layer.sublayer.query.gql"
import type {
  LayerSublayerQuery,
  LayerSublayerQueryVariables,
} from "@/v2-backoffice-client/layer/sublayer/__types__/layer.sublayer.query"

type Options = QueryHookOptions<LayerSublayerQuery, LayerSublayerQueryVariables>

/** The layer's catalog row in the authoring environment, for its Sublayers. */
export function useLayerSublayerQuery(options?: Options) {
  return useQuery<LayerSublayerQuery, LayerSublayerQueryVariables>(
    query,
    options,
  )
}
